import assert from '@/sui/tools/assert'
const f = (c, t, tt, i, td) => { return { c: c, t: t, tt: tt, i: i, td: td } }

export default {
  highlightTitles: function (type) {
    if (type === 'table') {
      return `VUE D'ENSEMBLE OBSERVA4`
    }

    const highlightContent =
        type === 'bySheet' ? 'PAR FICHES'
          : type === 'byTheme' ? 'PAR THEMES' : ''
    assert(highlightContent !== '', 'Missing observa 4 print sheet title')
    return `FAITS MARQUANTS OBSERVA4 ${highlightContent}`
  },

  titles: {
    bySheet: {
      p1: `P1 - Pose d'un cathéter veineux central (PICC, CVC, CDIA), d'un MID-PI ou d'un cathéter artériel`,
      p2: `P2 - Pose d'un CVP ou d'un MID sans PI`,
      p3: `P3 - Pose d'une aiguille sur CCI`,
      p4: `P4 - Pose d'un cathéter sous-cutané`,
      b1: 'B1 - Manipulation distale',
      b2: 'B2 - Manipulation proximale',
      r1: `R1 - Pansement d'un cathéter veineux central (PICC, CVC, CDIA), d'un MID-PI ou d'un cathéter artériel`
    },

    byTheme: {
      adt: `Hygiène de l'opérateur`,
      pat: 'Tenue du patient / résident',
      pcut: 'Préparation cutanée',
      manip: 'Préparation du site de branchement',
      ultrasound: `Échoguidage à l'insertion`,
      rinsingContinuous: `Rinçage pulsé - Opportunité`,
      rinsingDiscontinuous: `Rinçage pulsé - Opportunité`,
      rinsingTechnique: `Rinçage pulsé - Technique`,
      gts: 'Gants - Protection du professionnel',
      asep: `Gants - Respect de l'asepsie`,
      puton: `Gants - Enfilage au bon moment`
    }
  },

  subTitles: {
    byTheme: {
      rinsingContinuous: `Cathéter utilisé en continu`,
      rinsingDiscontinuous: `Cathéter utilisé en discontinu`
    },
    bySheet: {}
  },

  cat: {
    bySheet: {
      title: 'Par fiches',
      p1: `P1 - Pose d'un CVC, PICC, CDIA, MID-PI ou CA`,
      p2: `P2 - Pose d'un CVP ou d'un MID sans PI`,
      p3: `P3 - Pose d'une aiguille sur CCI`,
      p4: `P4 - Pose d'un cathéter sous-cutané`,
      b1: 'B1 - Manipulation distale',
      b2: 'B2 - Manipulation proximale',
      r1: `R1 - Pansement d'un CVC, PICC, CDIA, MID-PI ou CA`
    },

    byTheme: {
      title: 'Par thèmes',
      adt: `Hygiène de l'opérateur`,
      pat: 'Tenue du patient / résident',
      pcut: 'Préparation cutanée',
      manip: 'Préparation du site de branchement',
      ultrasound: `Échoguidage à l'insertion`,
      rinsingContinuous: `Rinçage pulsé (opportunité/continue)`,
      rinsingDiscontinuous: `Rinçage pulsé (opportunité/discontinue)`,
      rinsingTechnique: `Rinçage pulsé (technique)`,
      gts: 'Gants - Protection du professionnel',
      asep: `Gants - Respect de l'asepsie`,
      puton: `Gants - Enfilage au bon moment`

    }
  },

  priority: {
    gray: '0 à 49%',
    danger: '50 à 79%',
    warning: '80 à 89%',
    success: 'plus de 90%',
    info: 'Aucune cible'
  },

  facts: {
    p2: {

    },

    gown: f(
      'Casaque stérile', `Casaque<br>stérile`, `Port de casaque stérile : oui`
    ),
    mask: f(
      'Masque conforme',
      `Masque<br>conforme`,
      `Masque chirurgical : oui<br>Port conforme : oui`
    ),
    maska: f(
      '<span class="glyphicon glyphicon-user"></span> adulte >> Masque conforme',
      `Masque<br>conforme`,
      `Masque chirurgical : oui<br>Port conforme : oui`,
      'user',
      `Hors enfants<br>Hors masque SO`
    ),
    maskv: f(
      '<span class="glyphicon glyphicon-user"></span> adulte >> Masque conforme ou visage tourné',
      `Masque<br>conforme`,
      `Masque chirurgical : oui<br>
Port conforme : oui<br>
<strong>OU</strong><br>
Masque chirurgical : non<br>
Visage tourné : oui`,
      'user',
      `Hors enfants<br>Hors masque SO`
    ),
    maskva: f(
      'Masque conforme ou visage tourné',
      `Masque<br>conforme`,
      `Masque chirurgical : oui<br>
Port conforme : oui<br>
<strong>OU</strong><br>
Masque chirurgical : non<br>
Visage tourné : oui`,
      null,
      `Hors masque SO`
    ),
    cap: f(
      'Coiffe conforme',
      'Coiffe<br>conforme',
      `Port d'une coiffe : oui<br>Port conforme : oui`
    ),
    capa: f(
      '<span class="glyphicon glyphicon-user"></span> adulte >> Coiffe conforme',
      'Coiffe<br>conforme',
      `Port d'une coiffe : oui<br>Port conforme : oui`,
      'user',
      `Hors enfants`
    ),
    outf: f('Tenue propre', 'Tenue<br>propre', `Port d'une tenue propre : oui`),
    gss: f('Gants stériles', 'Gants<br>stériles', 'Port de gants : oui<br>Type de gants : stériles'),
    gsst: f(
      'Gants stériles au bon moment',
      'Gants stériles<br>au bon moment',
      'Port de gants : oui<br>Type de gants : stériles<br>Enfilés : avant la manipulation'
    ),
    gssp: f(
      'Gants stériles (si palpation)', 'Palpation et<br>Gants<br>stériles',
      'Port de gants : oui<br>Type de gants : stériles',
      null,
      'Si palpation du site'
    ),
    dcmf: y => y < 2023
      ? f(
        'DCMF conforme', 'DCMF<br>conforme',
        'HDM : oui<br>Désinfection chir. : friction<br>Technique conforme : oui'
      )
      : f(
        'DCMF conforme à la pose',
        'DCMF<br>conforme<br>à la pose',
        'HDM avant la pose : oui<br>Technique : DCMF<br>Technique conforme : oui'
      ),
    twof: f(
      'Deux frictions conformes',
      'Deux frictions<br>conformes',
      `<u>Pour les deux hdm</u><br>HDM : oui<br>Désinfection : par friction<br>Technique conforme: oui`
    ),
    hdm: f(
      'Friction conforme (branchement)', 'Friction<br>conforme',
      'HDM : oui<br>Désinfection : par friction<br>Technique conforme: oui'
    ),
    hdmp: f(
      'Friction conforme (préparation)', '1<sup>ère</sup> friction<br>conforme',
      'HDM avant la prépa. : oui<br>Désinfection : par friction<br>Technique conforme: oui'
    ),
    hdmip2: f(
      'Friction conforme (pose)', '2<sup>ème</sup> friction<br>conforme',
      'HDM avant la pose : oui<br>Désinfection : par friction<br>Technique conforme: oui'
    ),
    hdmip3: f(
      'Friction conforme (ponction)', '2<sup>ème</sup> friction<br>conforme',
      'HDM avant la ponction : oui<br>Désinfection : par friction<br>Technique conforme: oui'
    ),
    hdmib2: f(
      'Friction conforme (branchement)', '2<sup>ème</sup> friction<br>conforme',
      'HDM avant branchement : oui<br>Désinfection : par friction<br>Technique conforme: oui'
    ),
    glov: f('Port de gants', 'Gants', 'Port de gants : oui'),
    glovp: f(
      'Port de gants à la pose',
      'Gants à la pose',
      `Port de gants avant la pose: oui<br>
<strong>OU</strong><br>
Gants de l'étape précédente non retirés
`
    ),
    gloj: f(
      'Pas de gants ou gants justifiés', 'Pas de gants<br>ou justifiés',
      `Port de gants : non<br>
<strong>OU</strong><br>
Port de gants : oui<br>
Port justifié : oui`
    ),
    gloc: f(
      `Port de gants conforme`, 'Port de gants<br>conforme',
      `Gants nécessaire : non<br>
Port de gants : non<br>
<strong>OU</strong><br>
Gants nécessaire : oui<br>
Port de gants : oui<br>`
    ),
    pto: f(
      `Gants enfilés après antisepsie / juste avant insertion`,
      `Gants enfilés<br>au bon<br>moment`,
      `Gants : oui<br>
Enfilés : après antisepsie /<br>avant insertion`

    ),
    al70: f(
      'Alcool à 70%',
      'Alcool 70%',
      `Utilisation compresses : oui<br>Imprégnation : oui<br>Antiseptique : alcool à 70%`
    ),
    val70: f(
      'Technique conforme et alcool à 70%',
      'Alcool 70% et<br>technique<br>conforme',
      `Désinfection avant util. : oui<br>Technique conforme : oui<br>Antiseptique : alcool à 70%`,
      null,
      `Si utilisation d'une valve<br>`
    ),
    cpr: (all) => {
      return f(
        'Compresses conformes',
        'Compresses<br>conformes',
        'Appli. antiseptique : oui<br>Utilisation compresses : oui<br>Type de compresses : stériles',
        null,
        all ? null : `Hors ATS avec applicateur`
      )
    },
    dval: f(
      'Désinfection avant utilisation',
      'Désinfection',
      `Désinfection avant util. : oui`,
      null,
      `Si utilisation d'une valve`
    ),
    chcl: f(
      '<span class="glyphicon glyphicon-baby-formula"></span> enfant >> Nettoyage',
      'Nettoyage',
      `Nettoyage : oui<br><strong>OU</strong><br>Nettoyage : non<br>Appli. antiseptique : oui<br>Antiseptique : CHL 0.25%<br>Passages : au moins 2`,
      'baby-formula',
      `Hors adultes`
    ),
    chl2p: f(
      '<span class="glyphicon glyphicon-user"></span> adulte >> CHL 2%',
      'CHL 2%',
      `Appli. antiseptique : oui<br>Antiseptique : CHL 2%`,
      'user',
      `Hors enfants<br>
Hors MIDline avec PI`
    ),
    clean: f(
      '<span class="glyphicon glyphicon-user"></span> adulte >> Nettoyage si besoin',
      'Nettoyage si<br>besoin',
      `Nettoyage : oui`,
      'user',
      'Hors enfants<br>Si nettoyage nécessaire'
    ),
    asq: f(
      '<span class="glyphicon glyphicon-user"></span> adulte >> Antiseptique alcoolique',
      'Antiseptique<br>alcoolique',
      `Appli. antiseptique : oui<br>Antiseptique : alcoolique`,
      'user',
      'Hors enfants'
    ),
    dry: f(
      'Séchage spontané',
      'Séchage<br>spontané',
      'Appli. antiseptique : oui<br>Séchage spontané : oui',
      null,
      'Hors enfants < 1 mois'
    )
  }

}
